<template>
    <div class="slider-item slider-item--active">
        <h2 ref="title" class="slider-item__title">
            {{ $t.__('recap.slider.IntroductionSlide.title') }}
        </h2>
        <img src="/ressources/logged/img/illustrations/recap2024/shape-recap.svg" width="277" />
    </div>
</template>
<script>
import 'splitting/dist/splitting.css';
import 'splitting/dist/splitting-cells.css';
import Splitting from 'splitting';
import anime from 'animejs';

export default {
    name: 'IntroductionSlide',
    props: {
        isActive: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        isActive(value) {
            if (value) {
                anime({
                    targets: this.$refs.title.querySelectorAll('.word'),
                    translateY: [40, 0],
                    opacity: [0, 1],
                    delay: anime.stagger(100, { start: 600 }),
                });
            }
        },
    },
    mounted() {
        Splitting({ target: this.$refs.title, by: 'words' });
        if (this.isLoading) {
            anime({
                targets: this.$refs.title.querySelectorAll('.word'),
                translateY: [40, 0],
                opacity: [0, 1],
                delay: anime.stagger(100, { start: 600 }),
            });
        }
    },
};
</script>
<style lang="scss" scoped>
.slider-item {
    &__title {
        color: #fff;
        font-family: var(--font-families-stack-sans-text), sans-serif;
        font-size: 91px;
        font-weight: 400;
        margin: 0;
        position: relative;
        z-index: 1;

        :deep(.word) {
            opacity: 0;
        }
    }

    img {
        bottom: -2px;
        left: 0;
        position: absolute;
    }
}
</style>
